import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { addEvent, removeEvent } from '@flowio/browser-helpers';
import React from 'react';
var defaultProps = {
  capture: false,
  passive: true
};

var EventListener = /*#__PURE__*/function (_React$Component) {
  _inherits(EventListener, _React$Component);

  var _super = _createSuper(EventListener);

  function EventListener() {
    _classCallCheck(this, EventListener);

    return _super.apply(this, arguments);
  }

  _createClass(EventListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.attachListener();
    }
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate() {
      this.detachListener();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.attachListener();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.detachListener();
    }
  }, {
    key: "getEventTarget",
    value: function getEventTarget() {
      var target = this.props.target;
      return typeof target === 'string' ? window[target] : target;
    }
  }, {
    key: "attachListener",
    value: function attachListener() {
      var _this$props = this.props,
          capture = _this$props.capture,
          listener = _this$props.listener,
          passive = _this$props.passive,
          type = _this$props.type;
      var target = this.getEventTarget();

      if (target != null) {
        addEvent(target, type, listener, {
          capture: capture,
          passive: passive
        });
      }
    }
  }, {
    key: "detachListener",
    value: function detachListener() {
      var _this$props2 = this.props,
          capture = _this$props2.capture,
          listener = _this$props2.listener,
          passive = _this$props2.passive,
          type = _this$props2.type;
      var target = this.getEventTarget();

      if (target != null) {
        removeEvent(target, type, listener, {
          capture: capture,
          passive: passive
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children != null ? children : null;
    }
  }]);

  return EventListener;
}(React.Component);

_defineProperty(EventListener, "defaultProps", defaultProps);

export default EventListener;